import React from 'react'

import {animationTextData} from '../../data/animationText.data';

interface Props{
  isVideoOpened: boolean,
  currentCompleteCar: string
  handleShowVideo: (payload: boolean) => void
}

interface State{
  textToShow: any,
  currentIndexShowing: number
}

class VideoText extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      textToShow: null,
      currentIndexShowing: 0
    }
  }

  componentDidMount(): void {
    var tempData: any = animationTextData()
    this.setState({
      textToShow: tempData[this.props.currentCompleteCar][0]
    }, () => {
      this.handleStartSquence()
    })
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.isVideoOpened !== prevProps.isVideoOpened && this.props.isVideoOpened){
      var tempData: any = animationTextData()
      this.setState({
        textToShow: tempData[this.props.currentCompleteCar][0]
      }, () => {
        this.handleStartSquence()
      })
    }
    if(this.props.isVideoOpened !== prevProps.isVideoOpened && !this.props.isVideoOpened){
      this.setState({
        textToShow: null,
        currentIndexShowing: 0
      })
    }
  }

  handleStartSquence = () => {
    var animationText: any = animationTextData()
    var sequence = animationText[this.props.currentCompleteCar][0]
    var timeOut: number = 0

    sequence.forEach((element: any, index: number) => {
      var localTimeOut : number = element.duration
      setTimeout(() => {
        this.setState({ currentIndexShowing: index })
      }, timeOut);
      timeOut = timeOut + localTimeOut
    })
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isVideoOpened ? 'text-video-container fade-in':'text-video-container fade-out'}>
          {
            this.state.textToShow && this.state.textToShow.length > 0? 
            this.state.textToShow.map((element: any, index: number) => 
              <div className={this.state.currentIndexShowing === index ? 'video-text-generla-container fade-in':'video-text-generla-container fade-out'}>
                {
                  element.texts.map((text: any, indexText: number) => 
                    <div className={text.class}>
                      {text.text}
                    </div>
                  )
                }
              </div>  
            ):null
          }
          <div className='exit-text-video' onClick={() => {this.props.handleShowVideo(false)}}>
            Salir de la presentación
          </div>
        </div>
      )
  }
}

export default VideoText